import React from 'react';
import DetailedFields from '@modules/members/enrollments/EnrollmentListing/DetailedFields';
import { EMPTY_VALUE } from '../../constants';
import { IAddressDetailsSectionProps } from '../../types';
import { formatAddress } from '../../utils';

// ============================================================================
// Component
// ============================================================================

const AddressDetailsSection: React.FC<IAddressDetailsSectionProps> = ({
    id,
    homeAddress,
    mailingAddress,
    primaryTaxFilerNames,
}) => {
    const primaryTaxFiler = primaryTaxFilerNames?.length > 0 ? primaryTaxFilerNames.join(', ') : EMPTY_VALUE;

    return (
        <div id={id} className="grid-row margin-bottom-2" data-testid={id ? `address-details-${id}` : undefined}>
            <div className="grid-col-12 tablet:grid-col-6">
                <DetailedFields
                    label="historical.member.applications.homeAddress"
                    value={formatAddress(homeAddress)}
                    dataTestId="home-address"
                    showColon
                />
            </div>
            <div className="grid-col-12 tablet:grid-col-6">
                <DetailedFields
                    label="historical.member.applications.mailingAddress"
                    value={formatAddress(mailingAddress)}
                    dataTestId="mailing-address"
                    showColon
                />
            </div>
            <div className="grid-col-12 tablet:grid-col-6">
                <DetailedFields
                    label="historical.member.applications.primaryTaxFiler"
                    value={primaryTaxFiler || EMPTY_VALUE}
                    dataTestId="primary-tax-filer"
                    showColon
                />
            </div>
        </div>
    );
};

export default AddressDetailsSection;
